import HomeCurationItem from "../../shared/components/curation/HomeCurationItem";
import { createClient } from "@supabase/supabase-js";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CurationRepository from "../../repository/CurationRepository";
import PendingInvitations from "../../shared/components/pendinginvitations/PendingInvitations";
import UserRepository from "../../repository/UserRepository";
import FilterOptionChip from "../../shared/components/filteroptionchip/FilterOptionChip";
import { logEvent } from "firebase/analytics";
import { AnalyticsEvent } from "../../shared/analytics/AnalyticsEvent";
import { Helmet } from "react-helmet";
import { useYourCurationsContext } from "./YourCurationsContext";
import SideNav, { SideNavItem } from "./components/SideNav";
import MiddleNav from "./components/MiddleNav";
import AnalyticsRepository from "../../repository/AnalyticsRepository";
import { sendAction, sendPageView } from "../../shared/utils/AnalyticsUtils";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function YourCurationsPage({ analytics, userProfile, onSignOutClick, onTitleChange, onExploreClick, onSearchClick }) {

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const [loadingText, setLoadingText] = useState("Loading ...")
    const {combinedCurations, setCombinedCurations} = useYourCurationsContext()
    const [pendingInvitations, setPendingInvitations] = useState([])
    const [isInvitationSectionSaving, setIsInvitationSectionSaving] = useState(false)
    const [isFirstLoading, setIsFirstLoading] = useState(true)
    const navigate = useNavigate()

    async function getUserCurations() {
        const curationRepository = new CurationRepository()
        setLoadingText("Loading ...")
        const curationResponse = await curationRepository.getUserCurations()
        console.log(curationResponse)

        setCombinedCurations(
            curationResponse.combinedCurations.map((curation) => {

                let placeCount
                let memberCount
                if (curationResponse.curationPlaceCount[curation.id]) {
                    placeCount = curationResponse.curationPlaceCount[curation.id]
                } else {
                    placeCount = 0
                }
                if (curationResponse.curationMemberCount[curation.id]) {
                    memberCount = curationResponse.curationMemberCount[curation.id]
                } else {
                    memberCount = 0
                }
                return {
                    ...curation, placeCount: placeCount, memberCount: memberCount, author: curationResponse.userDetails[curation.authorUserId]
                }
            })
        )
        setLoadingText(null)
        setIsFirstLoading(false)
        onTitleChange("Your Collections")
      }

    useEffect(() => {

        console.log(`refetching everything`)
        Promise.all(
            [
                getUserCurations()
            ]
        )
        sendPageView(analytics, AnalyticsEvent.YOURS_VIEW)
    }, [])

    return (
        <div className="drawer h-full">
        <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content flex flex-col h-full max-h-full overflow-y-hidden">
        <div className="bg-base-100 flex flex-col md:min-h-[100vh] h-full">
            <Helmet>
                {
                    isFirstLoading && <title>Roambear | Trendiest restaurants in your city</title>
                }
                {
                    !isFirstLoading && <title>Your Collections | Roambear</title>
                }
            </Helmet>
            <div className="navbar bg-base-100 sticky top-0 z-10 md:hidden">
                <div className="items-center pl-4">
                    {/* <label htmlFor="my-drawer-3" aria-label="open sidebar" className="btn btn-square btn-ghost">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            className="inline-block h-6 w-6 stroke-neutral-content"
                        >
                            <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 6h16M4 12h16M4 18h16"
                            ></path>
                        </svg>
                    </label> */}
                    <img className="w-8 h-8" src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-shared-resources/roambear_logo.png"/>
                </div>
                
                <div className="flex-1 flex">
                </div>
                <div className="absolute left-1/2 -translate-x-1/2">
                    <MiddleNav 
                        selectedItem={SideNavItem.COLLECTION} 
                        onExploreClick={onExploreClick} 
                        onSearchClick={onSearchClick} 
                        onCollectionClick={() => {}}
                    />
                </div>
                {
                    userProfile && <div className="flex-none">
                    {/* <div tabIndex="0" role="button" className="btn btn-ghost md:btn-primary" onClick={() => {
                        navigate("/collections/add")
                    }}>
                        <div className="indicator">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path className="stroke-base-content md:stroke-primary-content" d="M4 12H20M12 4V20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </div>
                        <span className="hidden md:block text-base normal-case text-primary-content">Create Collection</span>
                    </div> */}
                    <div className="dropdown dropdown-end md:pl-4">
                        <div tabIndex="0" role="button" className="btn btn-ghost btn-circle avatar">
                            <div className="w-10 rounded-full border-4 border-primary flex">
                            { userProfile.user.profilePicture && <img src={  userProfile.user.profilePicture } /> }
                            { !userProfile.user.profilePicture && <span className="text-lg self-center w-full">{ userProfile.user.name[0] }</span> }
                            </div>
                            
                            {/* <div className="avatar placeholder w-10 h-10">
                            <div className="bg-neutral text-neutral-content rounded-full w-10 h-10">
                                <span className="text-xl">AI</span>
                            </div>
                            </div> */}
                        </div>
                        <ul tabIndex="0" className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
                            <li onClick={() => {
                                window.location.href = "/profile"
                            }}>
                            <div className="py-4">
                            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_429_11217)">
                                <path className="stroke-base-content" d="M4 18C4 15.7908 5.79086 14 8 14H16C18.2091 14 20 15.7908 20 18V18C20 19.1045 19.1046 20 18 20H6C4.89543 20 4 19.1045 4 18V18Z" strokeWidth="2.5" strokeLinejoin="round"/>
                                <circle cx="12" cy="6.99997" r="3" strokeWidth="2.5" className="stroke-base-content"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_429_11217">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>
                                <span className="text-base">View Profile</span>
                                </div>
                            </li>
                            <li onClick={() => {
                                window.location.href = "/profile/interests"
                            }}>
                            <div className="py-4">
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="stroke-base-content" d="M15.7 4C18.87 4 21 6.98 21 9.76C21 15.39 12.16 20 12 20C11.84 20 3 15.39 3 9.76C3 6.98 5.13 4 8.3 4C10.12 4 11.31 4.91 12 5.71C12.69 4.91 13.88 4 15.7 4Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span className="text-base">Update Interests</span>
                                </div>
                            </li>
                            <li>
                                <div className="py-4" onClick={() => { 
                                    sendAction(analytics, AnalyticsEvent.LOGOUT_CLICK, AnalyticsEvent.YOURS_VIEW)
                                    onSignOutClick()
                                }}>
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="fill-base-content" d="M12.9999 2C10.2385 2 7.99991 4.23858 7.99991 7C7.99991 7.55228 8.44762 8 8.99991 8C9.55219 8 9.99991 7.55228 9.99991 7C9.99991 5.34315 11.3431 4 12.9999 4H16.9999C18.6568 4 19.9999 5.34315 19.9999 7V17C19.9999 18.6569 18.6568 20 16.9999 20H12.9999C11.3431 20 9.99991 18.6569 9.99991 17C9.99991 16.4477 9.55219 16 8.99991 16C8.44762 16 7.99991 16.4477 7.99991 17C7.99991 19.7614 10.2385 22 12.9999 22H16.9999C19.7613 22 21.9999 19.7614 21.9999 17V7C21.9999 4.23858 19.7613 2 16.9999 2H12.9999Z"/>
                                <path className="fill-base-content" d="M13.9999 11C14.5522 11 14.9999 11.4477 14.9999 12C14.9999 12.5523 14.5522 13 13.9999 13V11Z"/>
                                <path className="fill-base-content" d="M5.71783 11C5.80685 10.8902 5.89214 10.7837 5.97282 10.682C6.21831 10.3723 6.42615 10.1004 6.57291 9.90549C6.64636 9.80795 6.70468 9.72946 6.74495 9.67492L6.79152 9.61162L6.804 9.59454L6.80842 9.58848C6.80846 9.58842 6.80892 9.58778 5.99991 9L6.80842 9.58848C7.13304 9.14167 7.0345 8.51561 6.58769 8.19098C6.14091 7.86637 5.51558 7.9654 5.19094 8.41215L5.18812 8.41602L5.17788 8.43002L5.13612 8.48679C5.09918 8.53682 5.04456 8.61033 4.97516 8.7025C4.83623 8.88702 4.63874 9.14542 4.40567 9.43937C3.93443 10.0337 3.33759 10.7481 2.7928 11.2929L2.08569 12L2.7928 12.7071C3.33759 13.2519 3.93443 13.9663 4.40567 14.5606C4.63874 14.8546 4.83623 15.113 4.97516 15.2975C5.04456 15.3897 5.09918 15.4632 5.13612 15.5132L5.17788 15.57L5.18812 15.584L5.19045 15.5872C5.51509 16.0339 6.14091 16.1336 6.58769 15.809C7.0345 15.4844 7.13355 14.859 6.80892 14.4122L5.99991 15C6.80892 14.4122 6.80897 14.4123 6.80892 14.4122L6.804 14.4055L6.79152 14.3884L6.74495 14.3251C6.70468 14.2705 6.64636 14.1921 6.57291 14.0945C6.42615 13.8996 6.21831 13.6277 5.97282 13.318C5.89214 13.2163 5.80685 13.1098 5.71783 13H13.9999V11H5.71783Z"/>
                                </svg>
                                <span className="text-base">Logout</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                }
            </div>
            <div className="flex flex-row flex-1 h-full">
            {
                    userProfile && <SideNav
                        selectedItem={SideNavItem.COLLECTION}
                        userProfile={userProfile}
                        onExploreClick={onExploreClick}
                        onSearchClick={onSearchClick}
                        onCollectionClick={() => {}}
                        onSignOutClick={onSignOutClick}
                        analytics={analytics}
                    />
            }
            <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:px-4 pb-36 pt-4 items-stretch flex-1 overflow-y-scroll h-min max-h-full">
                {
                    combinedCurations.map((curation) => {
                        return <div className="col-span-3" key={curation.id}>
                            <HomeCurationItem title={`${curation.title}`} 
                            url={`/collections/${curation.id}`}
                            description={curation.description}
                            numberOfPlaces={curation.placeCount}
                            numberOfContributors={curation.memberCount}
                            imageUrl={curation.coverPhoto} 
                            emoji={curation.emoji}
                            author={curation.author}
                            />
                        </div>
                    })
                }
                {!loadingText && !isFirstLoading && combinedCurations.length == 0 &&
                <div className='col-span-3 md:col-span-6 flex flex-col items-center justify-center pt-4'>
                    <div>
                    <svg className="w-16 h-16 fill-base-content" version="1.1" viewBox="0 0 310.883 310.883">
                        <path d="M299.459,174.267c0,0-16.433-71.773-16.707-72.356c-3.429-10.694-17.078-19.279-40.725-25.565
                            c-23.243-6.181-53.993-9.584-86.586-9.584c-32.592,0-63.343,3.403-86.586,9.584c-23.657,6.29-37.308,14.879-40.729,25.58
                            c-0.272,0.578-16.702,72.342-16.702,72.342C4.778,176.576,0,182.879,0,190.312c0,18.79,17.893,33.075,53.18,42.458
                            c27.533,7.32,63.85,11.353,102.261,11.353c0.002,0,0.004,0,0.006,0c38.41,0,74.724-4.031,102.255-11.352
                            c35.287-9.383,53.18-23.668,53.18-42.459C310.883,182.879,306.105,176.576,299.459,174.267z M211.452,189.198
                            c0,7.987-6.498,14.486-14.485,14.486c-7.755,0-14.107-6.124-14.471-13.79h-54.11c-0.365,7.666-6.715,13.79-14.469,13.79
                            c-7.988,0-14.486-6.499-14.486-14.486c0-3.783,1.458-7.232,3.842-9.815c-2.384-2.583-3.842-6.032-3.842-9.815
                            c0-7.987,6.499-14.486,14.486-14.486c7.754,0,14.104,6.124,14.469,13.79h54.11c0.364-7.666,6.716-13.79,14.471-13.79
                            c7.987,0,14.485,6.499,14.485,14.486c0,3.783-1.458,7.232-3.842,9.815C209.994,181.966,211.452,185.415,211.452,189.198z
                            M235.357,120c-21.545,5.448-49.926,8.449-79.916,8.449c-29.99,0-58.371-3.001-79.916-8.449
                            c-20.722-5.24-28.012-10.998-29.796-13.382c1.8-2.425,9.104-8.177,29.8-13.409c21.544-5.448,49.924-8.448,79.912-8.448
                            c29.987,0,58.367,3,79.911,8.448c20.654,5.223,27.97,10.961,29.789,13.395C263.329,109.033,256.023,114.773,235.357,120z"/>
                        </svg>
                    </div>
                    <div className='font-normal text-base-content mt-2'>Nothing here.</div>
                    <div className='font-normal text-base-content mt-2'>Press <span class="inline-flex items-baseline"><div className="btn btn-primary btn-sm mx-2 normal-case" onClick={() => {navigate("/collections/add")}}>+ Create Collection</div></span> to create a new one!</div>
                </div>
                }
                { /iPhone|iPad|iPod/i.test(userAgent) && <div className='fixed bottom-4 left-4 bg-transparent text-right md:hidden'>
                    <a href="https://apps.apple.com/us/app/roambear-bookmark-places/id6741089867">
                    <button className="btn md:btn-lg text-base btn-secondary normal-case rounded-full min-w-max">
                    <svg className="fill-secondary-content w-5 h-5"  viewBox="0 0 512 512">
                    <g id="7935ec95c421cee6d86eb22ecd114eed">

                    <path d="M248.644,123.476c-5.45-29.71,8.598-60.285,25.516-80.89
                            c18.645-22.735,50.642-40.17,77.986-42.086c4.619,31.149-8.093,61.498-24.826,82.965
                            C309.37,106.527,278.508,124.411,248.644,123.476z M409.034,231.131c8.461-23.606,25.223-44.845,51.227-59.175
                            c-26.278-32.792-63.173-51.83-97.99-51.83c-46.065,0-65.542,21.947-97.538,21.947c-32.96,0-57.965-21.947-97.866-21.947
                            c-39.127,0-80.776,23.848-107.19,64.577c-9.712,15.055-16.291,33.758-19.879,54.59c-9.956,58.439,4.916,134.557,49.279,202.144
                            c21.57,32.796,50.321,69.737,87.881,70.059c33.459,0.327,42.951-21.392,88.246-21.616c45.362-0.258,53.959,21.841,87.372,21.522
                            c37.571-0.317,67.906-41.199,89.476-73.991c15.359-23.532,21.167-35.418,33.11-62.023
                            C414.435,352.487,389.459,285.571,409.034,231.131z">

                    </path>

                    </g>

                    </svg> Get the iPhone App
                    </button>
                    </a>
                    </div>
                }
                { /Android/i.test(userAgent) && <div className='fixed bottom-4 left-4 bg-transparent text-right md:hidden'>
                    <a href="play.google.com/store/apps/details?id=com.roambear.roambearandroid">
                    <button className="btn md:btn-lg text-base btn-secondary normal-case rounded-full min-w-max" onClick={() => { }}>
                    <svg className="fill-secondary-content w-5 h-5" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.35 12.653l2.496-4.323c0.044-0.074 0.070-0.164 0.070-0.26 0-0.287-0.232-0.519-0.519-0.519-0.191 0-0.358 0.103-0.448 0.257l-0.001 0.002-2.527 4.377c-1.887-0.867-4.094-1.373-6.419-1.373s-4.532 0.506-6.517 1.413l0.098-0.040-2.527-4.378c-0.091-0.156-0.259-0.26-0.45-0.26-0.287 0-0.519 0.232-0.519 0.519 0 0.096 0.026 0.185 0.071 0.262l-0.001-0.002 2.496 4.323c-4.286 2.367-7.236 6.697-7.643 11.744l-0.003 0.052h29.991c-0.41-5.099-3.36-9.429-7.57-11.758l-0.076-0.038zM9.098 20.176c-0 0-0 0-0 0-0.69 0-1.249-0.559-1.249-1.249s0.559-1.249 1.249-1.249c0.69 0 1.249 0.559 1.249 1.249v0c-0.001 0.689-0.559 1.248-1.249 1.249h-0zM22.902 20.176c-0 0-0 0-0 0-0.69 0-1.249-0.559-1.249-1.249s0.559-1.249 1.249-1.249c0.69 0 1.249 0.559 1.249 1.249v0c-0.001 0.689-0.559 1.248-1.249 1.249h-0z"></path>
                    </svg><div>Get the Android App</div>
                    </button>
                    </a>
                    </div>
                }
                {
                    <button className="btn btn-circle btn-primary shadow-xl fixed bottom-4 right-4 md:right-8" onClick={() => {
                        navigate("/collections/add")
                     }}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path className="stroke-primary-content" d="M4 12H20M12 4V20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </button>
                }
                {loadingText &&
                <div className='col-span-3 md:col-span-6 flex flex-col items-center justify-center pt-4'>
                    <div className="loading loading-infinity loading-lg"></div>
                    <div className='font-normal text-base-content mt-2'>{loadingText}</div>
                </div>
                }
            </div>
            </div>
        </div>
        </div>
        <div className="drawer-side z-20">
            <label htmlFor="my-drawer-3" aria-label="close sidebar" className="drawer-overlay"></label>
            <ul className="menu bg-base-200 min-h-full w-80 p-4 gap-2">
            <li>
                <img 
                className="h-16 w-auto" 
                src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-shared-resources/logos/roambear-full-logo-two-colors.png" />
            </li>
            <li onClick={() => {
                onSearchClick()
            }}><a>
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="stroke-neutral-content/50" d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="text-base text-neutral-content/50">Search</span>
            </a></li>
            <li onClick={() => {
                onExploreClick()
            }}><a>
                <svg className="fill-neutral-content/50 w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M17.9842695,7.39078625 C18.1985588,6.64477525 17.4973604,5.9435768 16.7513494,6.1578661 L16.6494246,6.19284365 L9.57835679,9.02127078 L9.47282273,9.07079854 C9.30957453,9.15937167 9.17428758,9.29167162 9.08209683,9.45256344 L9.02127078,9.57835679 L6.19284365,16.6494246 L6.1578661,16.7513494 C5.9435768,17.4973604 6.64477525,18.1985588 7.39078625,17.9842695 L7.49271102,17.949292 L14.5637788,15.1208648 L14.6693129,15.0713371 C14.8325611,14.982764 14.967848,14.850464 15.0600388,14.6895722 L15.1208648,14.5637788 L17.949292,7.49271102 L17.9842695,7.39078625 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z"/>
                </svg>
                <span className="text-base text-neutral-content/50">Explore</span>
            </a></li>
            <li><a>
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="fill-neutral-content" fill-rule="evenodd" clip-rule="evenodd" d="M5.36129 3.46995C6.03579 3.16081 6.76287 3 7.50002 3C8.23718 3 8.96425 3.16081 9.63875 3.46995C10.3129 3.77893 10.9185 4.22861 11.4239 4.78788C11.7322 5.12902 12.2678 5.12902 12.5761 4.78788C13.5979 3.65726 15.0068 3.00001 16.5 3.00001C17.9932 3.00001 19.4021 3.65726 20.4239 4.78788C21.4427 5.91515 22 7.42425 22 8.9792C22 10.5342 21.4427 12.0433 20.4239 13.1705L14.2257 20.0287C13.0346 21.3467 10.9654 21.3467 9.77429 20.0287L3.57613 13.1705C3.07086 12.6115 2.67474 11.9531 2.40602 11.2353C2.13731 10.5175 2 9.75113 2 8.9792C2 8.20728 2.13731 7.44094 2.40602 6.72315C2.67474 6.00531 3.07086 5.34694 3.57613 4.78788C4.08157 4.22861 4.68716 3.77893 5.36129 3.46995Z"/>
                </svg>
                <span className="text-base font-bold">Collections</span>
            </a></li>
            </ul>
        </div>
        </div>
    )
}
